export default __webpack_public_path__ + "static/media/hemant.3b7e19fb.jpg";